import React from 'react';
import { Text } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

import { NormalItem } from '../../types/benefit';
import { ButtonDownload } from './common/ButtonDownload';
import { ButtonSignup } from './common/ButtonSignup';

export const NormalSubItem = (subItem: NormalItem) => {
  return (
    <Container key={subItem.content} hasButton={Boolean(subItem.button)}>
      <SubItemTextWarp key={subItem.content}>
        <Text variant='Body_13_Regular' color='textQuaternary'>
          &middot;
        </Text>
        <EllipsisWrap>
          <Text
            style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}
            variant='Body_13_Regular'
            color='textSecondary'
          >
            {subItem.content}
          </Text>
        </EllipsisWrap>

        {subItem.badge?.text && (
          <Badge>
            <Text variant='Caption_10_Medium' color='subRedPrimary' style={{ flexShrink: 0 }} as='span'>
              {subItem.badge.text}
            </Text>
          </Badge>
        )}
      </SubItemTextWarp>

      {subItem.button && (
        <div style={{ flexShrink: 0 }}>
          {subItem.button.type === 'download' && <ButtonDownload {...subItem.button} />}
          {subItem.button.type === 'signup' && <ButtonSignup {...subItem.button} />}
        </div>
      )}
    </Container>
  );
};

const Container = styled.div<{ hasButton: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  ${({ hasButton }) => (hasButton ? '' : 'padding: 4px 0;')};
`;

const SubItemTextWarp = styled.div`
  display: flex;
  gap: 6px;
  padding-left: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre;
`;

const Badge = styled.div`
  padding: 0 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  background: rgba(255, 51, 51, 0.05);
`;

const EllipsisWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre;
`;
